import React from 'react';

import { intakeSectionConfig } from '../../../../hooks/types';
import useIntakeBlockToggle from '../../../../hooks/useIntakeBlockToggle';
import styles from '../index.module.scss';
import EMRBlock from './EMRBlock';
import StartRtmBlock from './StartRtmBlock';
import TypeOfCareBlock from './TypeOfCareBlock';

const AdministrativeInformation = () => {
  const { isOn } = useIntakeBlockToggle();

  if (!intakeSectionConfig.administrative?.some((config) => isOn(config))) {
    return null;
  }

  return (
    <div className={styles.sectionWrapper}>
      <span className={styles.sectionTitle}>Administrative Information</span>
      <div className={styles.filedsWrapper}>
        <EMRBlock />
        <TypeOfCareBlock />
        <StartRtmBlock />
      </div>
    </div>
  );
};

export default AdministrativeInformation;
